export default __webpack_public_path__ + "static/media/abstractpaint.1e1a5d28.jpeg";